import request from '@a/js/upyunrequest'

// 文件上传云存储
export function UploadYun(params) {
  return request({
    url: '/bhy-assets',
    method: 'post',
    data: params,
  })
}
